import { css } from 'lit';
import { LitElement, css, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import resetScss from '@css/lib/reset.scss';
import sharedScss from '@css/shared.scss';
import utilityClassesCss from '@css/utilityClasses.css';
import bbuttonbaseScss from '@css/lib/bbuttonbase.scss';
import './app-icon';
import { isValidString } from '@/utils/utils';
import { ifDefined } from 'lit/directives/if-defined.js';

@customElement('app-btn')
export default class AppButton extends LitElement {
	@property({ type: String, reflect: true }) public icon = '';

	@property({ type: String, reflect: true }) public buttonTitle = '';

	@property({ type: String }) public link?: string = '';

	static override get styles() {
		return [
			resetScss,
			sharedScss,
			utilityClassesCss,
			bbuttonbaseScss,
			css`
				button,
				a {
					display: flex;
					align-items: center;
					gap: calc(var(--ggutter) / 2);
				}

				button:hover {
					color: rgb(var(--brand-focus)) !important;
				}

				::slotted(*) {
					color: rgb(var(--brand-focus));
				}
			`,
		];
	}

	onClick() {
		this.dispatchEvent(new CustomEvent('clicked'));
	}

	buttonTemplate() {
		return html`<button class="bbuttonbase" @click=${this.onClick} title=${this.title}>
			${this.icon ? html`<app-icon width="24" height="24" .href=${this.icon}></app-icon>` : nothing}
			<slot></slot>
		</button>`;
	}

	anchorTemplate() {
		return html`<a href=${ifDefined(this.link)} title=${this.title} target="_blank">
			${this.icon ? html`<app-icon width="24" height="24" .href=${this.icon}></app-icon>` : nothing}
			<slot></slot>
		</a>`;
	}

	override render() {
		if (isValidString(this.link)) {
			return this.anchorTemplate();
		}

		return this.buttonTemplate();
	}
}
